import { sendGTMEvent } from '@next/third-parties/google'

const signalEvent = (event: string) => {
  sendGTMEvent({ event })
}

export default {
  signalEvent,
}
